export interface BaseServiceNowParams {
  language: string;
  reportingCountry: string;
  sys_id?: string;
  id?: string;
  communicationLanguageCode: string;
  OSCContactID: string;
}

export interface NotificationActionParms {
  id: string;
  table: string;
  sys_id: string;
  language: string;
}
export interface CertificateParams extends BaseServiceNowParams {
  certificateNumber: string;
  revisionNumber: number;
  certificateID: number;
  certificateStatus: string;
  service: string;
  projectNumber: string;
  accountDNVId?: number;
  reportingUnit: string;
}

export interface InvoiceParams extends BaseServiceNowParams {
  invoice: string;
  status: string;
  projectNumber: string;
  accountDNVId?: number;
  reportingUnit: string;
}

export interface ScheduleParams extends BaseServiceNowParams {
  startDate: string;
  endDate: string;
  auditID: number;
  siteAuditID: number;
  site: string;
  status: string;
  siteAddress: string;
  siteCity: string;
  siteZip: string;
  siteCountry: string;
  siteState: string;
  service: string;
  projectNumber: string;
  accountDNVId?: number;
  reportingUnit: string;
}

export interface CompanySettingsParams extends BaseServiceNowParams {
  accountName: string;
  accountAddress: string;
  accountDNVId?: number;
}

export interface SitesSettingsParams extends BaseServiceNowParams {
  OSvCSiteID: string;
  accountDNVId?: number;
  siteName: string;
  siteNickname: string;
  siteAddress: string;
}

export type SitesSettingsSupportInput = Omit<
  SitesSettingsParams,
  'language' | 'reportingCountry' | 'communicationLanguageCode' | 'OSCContactID'
>;
